import axiosInstance from "./axiosInstance";

let meCache = null;
let meCacheAt = 0;
let inFlightMeRequest = null;

const SUCCESS_TTL_MS = 15000;
const FAILURE_TTL_MS = 2000;

export async function getCurrentUser({ force = false } = {}) {
    const now = Date.now();
    const ttl = meCache ? SUCCESS_TTL_MS : FAILURE_TTL_MS;

    if (!force && now - meCacheAt < ttl) {
        return meCache;
    }

    if (!force && inFlightMeRequest) {
        return inFlightMeRequest;
    }

    inFlightMeRequest = axiosInstance
        .get("/user/me")
        .then(({ data }) => {
            meCache = data || null;
            meCacheAt = Date.now();
            return meCache;
        })
        .catch(() => {
            meCache = null;
            meCacheAt = Date.now();
            return null;
        })
        .finally(() => {
            inFlightMeRequest = null;
        });

    return inFlightMeRequest;
}

export function clearCurrentUserCache() {
    meCache = null;
    meCacheAt = 0;
    inFlightMeRequest = null;
}
